<template>
  <div class="pagePrint" style="height: 100vh">
    <div style="width: 100%;">
      <img src="../assets/logo.png" class="print-logo" /><span class="print-header-text">EMS - VOP Platform -
        v{{ version }} - {{ printDate }}<br />Data From:{{ formatDate(printdetails.DateFrom) }} -
        To:{{ formatDate(printdetails.DateTo) }}<br /></span>
    </div>

    <div class="row" style="width: 100%;color: black; padding-left:30px; padding-right:30px;">


      <div style="text-align: center;margin-top:60px">


        <h6><strong>FUEL OIL CONSUMPTION REPORTING AND OPERATIONAL CARBON INTENSITY RATING</strong></h6>


      </div>



    </div>

    <div class="row"
      style="width: 100%;color: black; padding-left:30px; padding-right:30px; text-align: center; margin-top:30px">


    </div>


    <div class="row"
      style="width: 100%;color: black; padding-left:30px; padding-right:30px; text-align: left; margin-top:30px">
      <strong>Particulars of Ship</strong>


      <div style=" text-align: left; margin-top: 30px; ">
        <strong>Name of The Ship:</strong><span style="margin-left:30px"> {{ printdetails.ShipName }}</span>
        <hr class="hrdots" style="width: 100%; margin-top:4px;" />
      </div>

      <div style=" text-align: left; margin-top: 10px; ">
        <strong>Distinctive number of letters:</strong><span style="margin-left:30px"> {{ printdetails.ShipCode
          }}</span>
        <hr class="hrdots" style="width: 100%; margin-top:4px;" />
      </div>


      <div style=" text-align: left; margin-top: 10px; ">
        <strong>IMO Number:</strong><span style="margin-left:30px"> {{ printdetails.IMO }}</span>
        <hr class="hrdots" style="width: 100%; margin-top:4px;" />
      </div>

      <div style=" text-align: left; margin-top: 10px; ">
        <strong>Capacity:</strong><span style="margin-left:30px"> {{ printdetails.DeadWeight }}</span>
        <hr class="hrdots" style="width: 100%; margin-top:4px;" />
      </div>

      <div style=" text-align: left; margin-top: 10px; ">
        <strong>Type of Ship:</strong><span style="margin-left:30px"> {{ abbShipDetails }}</span>
        <hr class="hrdots" style="width: 100%; margin-top:4px;" />
      </div>



    </div>

    <div class="row"
      style="width: 100%;color: black; padding-left:30px; padding-right:30px; text-align: left; margin-top:60px">
      <strong>THIS IS TO DECLARE THAT:</strong>
      <div>


        <table style="width: 100%;">
          <tr>
            <td width="10%" style="font-size: 16px; vertical-align: top;">1</td>
            <td width="90%">the ship has submitted the data required covering ship operations
              from {{ formatDate(printdetails.DateFrom) }} to
              {{ formatDate(printdetails.DateTo) }}</td>
          </tr>

          <tr>
            <td width="10%" style="font-size: 16px; vertical-align: top;">2</td>
            <td width="90%">the attained operational CII of the ship from {{ formatDate(printdetails.DateFrom) }}
              through
              {{ formatDate(printdetails.DateTo) }} was {{ printdetails.CII }} grCO2/nm*mt and the required CII is {{
          printdetails.RequiredCII }} grCO2/nm*mt</td>
          </tr>
          <tr>
            <td width="10%">3</td>
            <td width="90%">the operational carbon intensity of the ship in this period is rated as:</td>
          </tr>
          <tr>
            <td width="10%"></td>
            <td width="90%">
              <h4><strong>{{ printdetails.CarbonRating }}</strong></h4>
            </td>
          </tr>

        </table>




      </div>
    </div>


    <div class="row"
      style="width: 100%;color: black; padding-left:30px; padding-right:30px; text-align: left; margin-top:50px">


      <div style=" text-align: center; ">
        {{ printdetails.IssueAt }} , {{ printdetails.Country }}
        <hr class="hrdots" style="width: 100%; margin-top:4px;" />
        Place of issue (place, country)
      </div>


      <!-- <div style=" text-align: center;  margin-top: 30px; ">
        <div>{{ printdetails.IssueAt }}</div>
        <hr class="hrdots" style="width: 100%; margin-top:4px;" />
        (place of issue)
      </div> -->

      <div style=" text-align: center; margin-top: 40px; ">
        <div>{{ printDate }}</div>
        <hr class="hrdots" style="width: 100%; margin-top:4px;" />
        Date of issue (date)
      </div>

      <!-- <div style=" text-align: center; margin-top: 90px; ">
        <div></div>
        <hr class="hrdots" style="width: 100%; margin-top:4px;" />
        (signature)
      </div> -->


      <div style=" text-align: center; margin-top: 40px; ">
        by {{ printdetails.IssueBy }}
        <hr class="hrdots" style="width: 100%; margin-top:4px;" />
        Issued by (Name of officer)
      </div>




    </div>



    <div class="row"
      style="width: 100%;color: black; padding-left:30px; padding-right:30px; text-align: left; margin-top:30px">
      <div>




      </div>
    </div>


  </div>
</template>

<script>

export default {
  name: "Print Page",
  components: {
  },
  data() {
    return {
      printdetails: {},
      load: false,
      dateValueFrom: "",
      dateValueTo: "",
    };
  },
  methods: {
    formatDate(value) {
      let dateArray = value.split("T");
      return dateArray[0] + " " + dateArray[1];
    },
  },
  computed: {
    version() {
      return process.env.VUE_APP_VERSION;
    },
    abbShipDetails() {
      return this.printdetails.shipType.split(' ').slice(0, 3).join(' ');
     },
    printDate() {
      let date = new Date();
      let day = String(date.getDate()).padStart(2, '0');
      let month = String(date.getMonth() + 1).padStart(2, '0');
      let year = date.getFullYear();
      let h = String(date.getHours()).padStart(2, '0');
      let m = String(date.getMinutes()).padStart(2, '0');
      let s = String(date.getSeconds()).padStart(2, '0');
      let prDate = year + "-" + month + "-" + day + " " + h + ":" + m + ":" + s;
      return prDate;
    },
  },
  mounted() {
    setTimeout(() => {
      this.load = true;
    }, 1000);
    setTimeout(() => {
      window.print();
      window.close();
    }, 1000);
  },
  created() {
    this.printdetails = JSON.parse(sessionStorage.getItem("documentdetails"));
  },
};
</script>


<style scoped>
body {
  -webkit-print-color-adjust: exact !important;
  -webkit-print-color-adjust: exact !important;
  background-color: white !important;
}

.hrdots {
  border: none;
  border-top: 1px dotted #000;
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 50%;
}
</style>